import React, { useEffect, useState } from 'react';

const Darkmode = () => {
    const [theme, setTheme] = useState('dark');

    useEffect(() => {
        const getStoredTheme = () => {
            try {
                return window.localStorage.getItem('theme');
            } catch (error) {
                return null;
            }
        };

        const storedTheme = getStoredTheme();
        const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
        const initialTheme = storedTheme === 'light' || storedTheme === 'dark'
            ? storedTheme
            : prefersDark ? 'dark' : 'light';

        document.body.classList.toggle('light', initialTheme === 'light');
        setTheme(initialTheme);

        try {
            window.localStorage.setItem('theme', initialTheme);
        } catch (error) {
            // ignore localStorage errors
        }
    }, []);

    const switchTheme = () => {
        const nextTheme = theme === 'light' ? 'dark' : 'light';
        document.body.classList.toggle('light', nextTheme === 'light');
        setTheme(nextTheme);
        try {
            window.localStorage.setItem('theme', nextTheme);
        } catch (error) {
            // ignore localStorage errors
        }
    };

    return (
        <button id="darkmode" className={theme === 'light' ? 'clicked' : ''} onClick={switchTheme}>
           <img className="light-icon" src={`${process.env.PUBLIC_URL}/images/icons/sun-01.svg`} alt="Sun images" />
           <img className="dark-icon" src={`${process.env.PUBLIC_URL}/images/icons/vector.svg`} alt="Sun images" />
        </button>
    );
};

export default Darkmode;